import { S25Util } from "../../../util/s25-util";
import { Connect25EmailTemplateApi, type SeEmailTemplateDto } from "./connect25.email.template.api";

export function normalizeConnect25TemplateOrgIds(orgIds: number[]): number[] {
    return [...new Set(orgIds.filter(Number.isFinite))].sort((left, right) => left - right);
}

/** Stable resource param key for Angular `resource` reload when org selection changes. */
export function connect25TemplateOrgIdsParamKey(orgIds: number[]): string {
    return normalizeConnect25TemplateOrgIds(orgIds).join("+");
}

export function parseConnect25TemplateOrgIdsParamKey(key: string): number[] {
    return normalizeConnect25TemplateOrgIds(S25Util.parseIntListFromPlusSeparated(key));
}

export async function loadConnect25TemplatesForOrgIds(orgIds: number[]): Promise<SeEmailTemplateDto[]> {
    const uniqueSorted = normalizeConnect25TemplateOrgIds(orgIds);
    if (!uniqueSorted.length) {
        return [];
    }
    if (uniqueSorted.length === 1) {
        return Connect25EmailTemplateApi.listForOrg(uniqueSorted[0], false);
    }
    return Connect25EmailTemplateApi.listInstitutionIntersectionForOrgs(uniqueSorted, false);
}
